import { object, string, number, array } from 'yup';
import { uniqBy } from 'lodash';

export default object().shape({
    Trunks:
        array()
            .of(
                object().shape({
                    Name:
                        string()
                            .required('REQUIRED'),
                    AccessNumber:
                        number()
                            .typeError('REQUIRED')
                            .required('REQUIRED')
                })
            )
            .test({
                name: 'trunkNamesValidator',
                exclusive: true,
                message: 'UNIQUE_NAME_ACCESS_NUMBER',

                /**
                 * Check for duplicates by name and access number
                 *
                 * @param {Object} value - Each trunk of the trunks array
                 * @returns {boolean} True if there are no duplicates, false otherwisen
                 */
                test(value) {
                    const initialLength = value.length;
                    const noDuplicatesByNameLength = uniqBy(value, 'Name').length;
                    const noDuplicatesByAccessNumber = uniqBy(value, 'AccessNumber').length;

                    return initialLength === noDuplicatesByNameLength && initialLength === noDuplicatesByAccessNumber;
                }
            })
});
